/**
 * In-panel clipboard for Sample Manager cut / copy / paste.
 * Copy → paste duplicates PCM into the target folder.
 * Cut → paste moves the sample (or folder) into the target folder.
 */
export type SampleClipboardEntry =
  | { kind: "sample"; mode: "cut" | "copy"; id: string }
  | { kind: "folder"; mode: "cut" | "copy"; id: string };

let clipboard: SampleClipboardEntry | null = null;

export function getSampleClipboard(): SampleClipboardEntry | null {
  return clipboard;
}

export function setSampleClipboard(next: SampleClipboardEntry | null): void {
  clipboard = next;
}

export function clearSampleClipboard(): void {
  clipboard = null;
}

export function hasSampleClipboard(): boolean {
  return clipboard != null;
}

export function sampleClipboardIsCut(id: string): boolean {
  return clipboard?.mode === "cut" && clipboard.id === id;
}
